import ScriptLoader from "./ScriptLoader";
import * as path from "path";
import CSSLoader from "./CSSLoader";

export default class Loader {
    public static async load(filePaths): Promise<any> {
        const jsFilePaths: string[] = [];
        const cssFilePaths: string[] = [];
        filePaths.forEach(filePath => {
            switch (path.extname(filePath)) {
                case ".js":
                    jsFilePaths.push(filePath);
                    break;
                case ".css":
                    cssFilePaths.push(filePath);
                    break;
                default:
                    console.log("could not find appropriate loader for file ", filePath);
            }
        });

        const p1 = ScriptLoader.loadSync(jsFilePaths);
        const p2 = CSSLoader.loadAll(cssFilePaths);
        await Promise.all([p1, p2]);
        return {};
    }
}
